import { getContext, setContext } from 'svelte'
import { createFriendsStore, type FriendsStore } from './stores/friends.svelte'
import {
  createNewAccessoriesStore,
  type NewAccessoriesStore,
} from './stores/new-accessories'
import {
  createNewAchievementsStore,
  type NewAchievementsStore,
} from './stores/new-achievements'
import type { PageDataSession } from './types'
import type { TypedSupabaseClient } from './supabase'

/**
 * This context is created from the root +layout.svelte file, and shared down to
 * all components, if the user is authenticated.
 */
type AuthContext = {
  /** Any new accessories that were unlocked during the current user session. */
  newAccessories: NewAccessoriesStore
  /** Any new achievements that were unlocked during the current user session. */
  newAchievements: NewAchievementsStore

  /** A store that holds all friends for the signed in user. */
  friends: FriendsStore
}

const _key = {}

/** Created once in the root +layout.svelte file. */
export const createAndSetAuthContext = (dependencies: {
  supabase: TypedSupabaseClient
  session: PageDataSession | null
}) => {
  const newAccessories = createNewAccessoriesStore(dependencies)
  const newAchievements = createNewAchievementsStore(dependencies)

  const userId = $derived(dependencies.session?.user.id ?? null)

  const friends = createFriendsStore(
    {
      get supabase() {
        return dependencies.supabase
      },
      get userId() {
        return userId
      },
    },
    () => newAchievements.reload(),
  )

  setContext<AuthContext>(_key, {
    newAccessories,
    newAchievements,
    friends,
  })
}
export const getAuthContext = (): AuthContext => getContext<AuthContext>(_key)
